export default "__VITE_ASSET__CNUd6Ze5__"